import { createFileRoute } from "@tanstack/react-router";
import { BlogPage } from "@/content-site/components/blog-page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
export const Route = createFileRoute("/_content/blog/")({
  loader: () => loadContentPage(["blog"]),
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <BlogPage data={Route.useLoaderData()} />;
}
